// import { useState } from 'react';
// import axios from 'axios';
import styles from './FormPoems.module.css';

//import InputForm from '../../components/InputForm';
//import Button from '../../components/Button';

import BannerConcurso from '../../assets/Concurso_poesia2.png'
import BannerConcursoMobile from '../../assets/Concurso_poesia2_mobile.png'

export default function FormPoems() {
  // const [poem, setPoem] = useState({
  //   categoria: '',
  //   nome: '',
  //   telefone: '',
  //   endereco: '',
  //   comprovante_endereco: null,
  //   documento: null,
  //   responsavel: '',
  //   nome_responsavel: '',
  //   poemaTexto: '',
  //   poemaArquivo: null,
  //   estilo: '',
  // });

  // const [formKey, setFormKey] = useState(0);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   const finalValue = name === 'telefone' ? formatCelular(value) : value;
  //   setPoem({
  //     ...poem,
  //     [name]: finalValue,
  //   });
  // };

  // const handleFileChange = (e) => {
  //   const { name, files } = e.target;
  //   if (files.length > 0) {
  //     setPoem({
  //       ...poem,
  //       [name]: files[0],
  //     });
  //   }
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!poem.categoria || !poem.nome || !poem.telefone || !poem.endereco || !poem.comprovante_endereco || !poem.documento) {
  //     alert('Por favor, preencha todos os campos obrigatórios e anexe os arquivos (comprovante de endereço e documento).');
  //     return;
  //   }

  //   if ((poem.categoria === 'Lindoaldo Campos' || poem.categoria === 'Vinícius Gregório') && !poem.estilo) {
  //     alert('Por favor, selecione o estilo do poema.');
  //     return;
  //   }

  //   if (poem.categoria === 'Lindoaldo Campos' && (!poem.responsavel || !poem.nome_responsavel || !poem.poemaTexto)) {
  //     alert('Por favor, preencha todos os campos específicos para a categoria Lindoaldo Campos.');
  //     return;
  //   }

  //   if (poem.categoria === 'Vinícius Gregório' && !poem.poemaTexto) {
  //     alert('Por favor, preencha o poema.');
  //     return;
  //   }

  //   if (poem.categoria === 'Arlindo Lopes' && !poem.poemaArquivo) {
  //     alert('Por favor, anexe o arquivo do poema.');
  //     return;
  //   }

  //   const telefoneFormatado = formatCelular(poem.telefone);
    
  //   const formData = new FormData();
  //   formData.append('categoria', poem.categoria);
  //   formData.append('nome', poem.nome);
  //   formData.append('telefone', telefoneFormatado);
  //   formData.append('endereco', poem.endereco);
  //   formData.append('comprovante_endereco', poem.comprovante_endereco);
  //   formData.append('documento', poem.documento);

  //   if (poem.categoria === 'Lindoaldo Campos') {
  //     formData.append('responsavel', poem.responsavel);
  //     formData.append('nome_responsavel', poem.nome_responsavel);
  //     formData.append('poemaTexto', poem.poemaTexto);
  //     formData.append('estilo', poem.estilo);
  //   } else if (poem.categoria === 'Vinícius Gregório') {
  //     formData.append('poemaTexto', poem.poemaTexto);
  //     formData.append('estilo', poem.estilo);
  //   } else if (poem.categoria === 'Arlindo Lopes') {
  //     formData.append('poemaArquivo', poem.poemaArquivo);
  //   }

  //   axios.post('https://back-cultura-sje-production.up.railway.app/register-poem', formData, {
  //     headers: { 
  //       'Content-Type': 'multipart/form-data' 
  //     }
  //   })
  //     .then(() => {
  //       setPoem({
  //         categoria: '',
  //         nome: '',
  //         telefone: '',
  //         endereco: '',
  //         comprovante_endereco: null,
  //         documento: null,
  //         responsavel: '',
  //         nome_responsavel: '',
  //         poemaTexto: '',
  //         poemaArquivo: null,
  //         estilo: '',
  //       });

  //       setFormKey((prev) => prev + 1);
  //       alert('Inscrição registrada com sucesso.')
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.data && error.response.data.message) {
  //         alert(`Erro: ${error.response.data.message}`);
  //       } else {
  //         console.error('Erro no envio do formulario',  JSON.stringify(error, null, 2));
  //       }
  //     });
  // };

  // function formatCelular(value) {
  //   value = value.replace(/\D/g, '');
  //   value = value.slice(0, 11); 
  //   value = value.replace(/^(\d{2})(\d)/, '($1) $2');
  //   value = value.replace(/(\d{5})(\d)/, '$1-$2');
  //   return value;
  // }

  return (
    <main className={styles.page}>
      <picture>
        <source media="(max-width: 768px)" srcSet={BannerConcursoMobile} />
        <img src={BannerConcurso} alt="Banner 1º Concurso de Poesia de Reis" className={styles.banner} />
      </picture>
      <div className={styles.container}>
        <h2>Inscrições encerradas!</h2>
      </div>
      <div className={styles.container}>
        <div className={styles.linksContainer}>
          <a href="https://drive.google.com/file/d/1ogQvCSyONlZ2d-sS-HNpV0gBb2_NXtbk/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>EDITAL</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
          <a href="https://drive.google.com/file/d/1SGjxB9xmRs3pwLBNATM5WJ5a6TdGqaNu/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>ANEXO I - CRONOGRAMA</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
          <a href="https://docs.google.com/document/d/1owpZxpjlajmrypYFCazcsKOveHOL3tUo/edit?usp=drive_link&ouid=105220049041684507451&rtpof=true&sd=true" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>ANEXO II - CARTA DE AUTORIZAÇÃO</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
          <a href="https://drive.google.com/file/d/1MHN2N0V7e1ptiaORrgi7z1c7L7_iQKU4/view?usp=sharing" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>ERRATA Nº 01_2026 PRORROGAÇÃO DE CRONOGRAMA EDITAL CONCURSO DE POESIA</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
          <a href="https://drive.google.com/file/d/1QxNmFrw5g75OB8TXQt7F1UK5eW9cBljb/view?usp=sharing" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>ANEXO I - CRONOGRAMA ATUALIZADO</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
          <a href="https://drive.google.com/file/d/1Dc2NSrC5DWswMaN0Ck3P0KaPsQ7lWH-k/view?usp=sharing" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>ERRATA Nº 02_2026 PRORROGAÇÃO DE CRONOGRAMA EDITAL CONCURSO DE POESIA</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
          <a href="https://drive.google.com/file/d/1Cf6pUiDeo9uSIIKlS3e0F7T-SivaXZDL/view?usp=sharing" target="_blank" rel="noopener noreferrer" className={styles.linkCard}>
            <span className={styles.linkTitle}>Vencedores do concurso de poesia</span>
            <span className={styles.linkAction}>Acessar ↗</span>
          </a>
        </div>
        {/* <form key={formKey} onSubmit={handleSubmit} className={styles.formContainer}>
          <InputForm
            mode='select'
            name='categoria'
            title='Categoria'
            value={poem.categoria}
            onChange={handleChange}
            options={[
              { value: '', name: 'Selecione uma categoria' },
              { value: 'Lindoaldo Campos', name: 'Lindoaldo Campos' },
              { value: 'Vinícius Gregório', name: 'Vinícius Gregório' },
              { value: 'Arlindo Lopes', name: 'Arlindo Lopes' },
            ]}
          />
          <InputForm
            mode='input'
            type='text'
            name='nome'
            title='Nome Completo'
            placeholder='Digite seu nome completo'
            value={poem.nome}
            onChange={handleChange}
          />
          <InputForm
            mode='input'
            type='tel'
            name='telefone'
            title='Telefone'
            placeholder='Digite seu número de celular'
            value={poem.telefone}
            onChange={handleChange}
          />
          <InputForm
            mode='input'
            type='text'
            name='endereco'
            title='Endereço'
            placeholder='Digite seu endereço'
            value={poem.endereco}
            onChange={handleChange}
          />
          <InputForm
            mode='input'
            type='file'
            name='comprovante_endereco'
            title='Comprovante de endereço (foto, pdf)'
            onChange={handleFileChange}
            accept='image/*, application/pdf'
            required={!poem.comprovante_endereco}
            marginBottom={poem.categoria === 'Lindoaldo Campos' ? '0.5rem' : '1.5rem'}
          />
          {poem.categoria === 'Lindoaldo Campos' && (
            <span style={{ fontSize: '12px', color: '#666', display: 'block', marginTop: '-0.25rem', marginBottom: '1.5rem' }}>
              *Documento de matrícula para alunos da rede municipal, será aceito como comprovante de residência.
            </span>
          )}
          {poem.categoria && (
            <div style={{ marginBottom: (poem.categoria === 'Arlindo Lopes' || poem.categoria === 'Lindoaldo Campos') ? '1.5rem' : '0' }}>
              <InputForm
                mode='input'
                type='file'
                name='documento'
                title={
                  poem.categoria === 'Lindoaldo Campos'
                    ? 'Carta de autorização / Documento Matrícula (foto, pdf, docx)'
                    : poem.categoria === 'Vinícius Gregório'
                    ? 'Documento com foto (foto, pdf)'
                    : 'Documento com foto / Carta de autorização / Documento Matrícula (foto, pdf, docx)'
                }
                onChange={handleFileChange}
                accept={
                  poem.categoria === 'Vinícius Gregório'
                    ? 'image/*, application/pdf'
                    : 'image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                }
                required={!poem.documento}
                marginBottom={(poem.categoria === 'Arlindo Lopes' || poem.categoria === 'Lindoaldo Campos') ? '0.5rem' : '1.5rem'}
              />
              {poem.categoria === 'Arlindo Lopes' && (
                <span style={{ fontSize: '12px', color: '#666', display: 'block', marginTop: '-0.25rem', marginBottom: '0.25rem' }}>
                  *Caso o participante seja menor de idade, preencha e envie o documento "ANEXO II - CARTA DE AUTORIZAÇÃO" ou documento matrícula.
                </span>
              )}
              {(poem.categoria === 'Arlindo Lopes' || poem.categoria === 'Lindoaldo Campos') && (
                <span style={{ fontSize: '12px', color: '#666', display: 'block', marginTop: poem.categoria === 'Lindoaldo Campos' ? '-0.25rem' : '0' }}>
                  *Documento de matrícula só será aceito para alunos da rede municipal.
                </span>
              )}
            </div>
          )}

          {poem.categoria === 'Lindoaldo Campos' && (
            <>
              <InputForm
                mode='select'
                name='responsavel'
                title='Responsável'
                value={poem.responsavel}
                onChange={handleChange}
                options={[
                  { value: '', name: 'Selecione o responsável' },
                  { value: 'Professor(a)', name: 'Professor(a)' },
                  { value: 'Familiar', name: 'Familiar' },
                ]}
              />
              <InputForm
                mode='input'
                type='text'
                name='nome_responsavel'
                title='Nome do Responsável'
                placeholder='Digite o nome do responsável'
                value={poem.nome_responsavel}
                onChange={handleChange}
              />
              <InputForm
                mode='textarea'
                name='poemaTexto'
                title='Poema'
                placeholder='Digite seu poema...'
                value={poem.poemaTexto}
                onChange={handleChange}
              />
            </>
          )}
          {poem.categoria === 'Vinícius Gregório' && (
            <InputForm
              mode='textarea'
              name='poemaTexto'
              title='Poema'
              placeholder='Digite seu poema...'
              value={poem.poemaTexto}
              onChange={handleChange}
            />
          )}

          {poem.categoria === 'Arlindo Lopes' && (
            <InputForm
              mode='input'
              type='file'
              name='poemaArquivo'
              title='Arquivo do Poema (pdf, docx)'
              onChange={handleFileChange}
              accept='application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              required={!poem.poemaArquivo}
            />
          )}
          {(poem.categoria === 'Lindoaldo Campos' || poem.categoria === 'Vinícius Gregório') && (
            <InputForm
              mode='select'
              name='estilo'
              title='Estilo do Poema'
              value={poem.estilo}
              onChange={handleChange}
              options={[
                { value: '', name: 'Selecione o estilo do poema' },
                { value: 'Quadra', name: 'Quadra' },
                { value: 'Sextilha', name: 'Sextilha' },
                { value: 'Sétima', name: 'Sétima' },
                { value: 'Décima', name: 'Décima' },
                { value: 'Décima com mote', name: 'Décima com mote' },
                { value: 'Soneto', name: 'Soneto' },
              ]}
            />
          )}

          <div className={styles.button}>
            <Button>Enviar</Button>
          </div>
        </form> */}
      </div>
    </main>
  )
}
